// extracted by mini-css-extract-plugin
export default {"logo":"wIqDRb","logoBeta":"y32rWq","link":"U9nfsa"};